const testimonials = [
  {
    name: "Staff Sergeant Miguel R.",
    location: "Fort Johnson, LA",
    rating: 5,
    text: "Got PCS orders to Camp Humphreys in South Korea with 35 days to report. My wife's passport was expired and my son's had never been done. Fast Passport Center handled both at the same time — my wife's renewal and my son's first passport. We had both documents in 8 business days. Made our report date in Korea with room to spare. Every Fort Johnson family should know about these guys.",
    service: "Military Family PCS Passports",
  },
  {
    name: "Dr. Susan P.",
    location: "Alexandria, LA",
    rating: 5,
    text: "I'm a hospitalist at Rapides Regional and was invited to present at a cardiology symposium in Vienna on about 5 weeks' notice. My passport had 4 months left — not enough for Austria. Fast Passport Center expedited my renewal in 6 business days. I presented in Vienna and got wonderful feedback. The service was professional and genuinely stress-free. I recommended them to three colleagues afterward.",
    service: "Passport Renewal",
  },
  {
    name: "James H.",
    location: "Pineville, LA",
    rating: 5,
    text: "I run a sugarcane operation in Rapides Parish and got invited to a trade delegation trip to São Paulo on short notice. Never had to renew my passport on a rush before — didn't even know where to start without driving all the way to New Orleans. Fast Passport Center explained the whole process, I shipped from Pineville overnight, and had my renewed passport in 7 days. Made the trip, signed two new contracts.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function AlexandriaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Central Louisiana Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Alexandria, Pineville, and Fort Johnson travelers who trusted Fast Passport Center with their expedited passports — without the 400-mile round trip to New Orleans.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}